import { ApolloLink } from '@apollo/client/link/core';
export class FederatedMultiLink extends ApolloLink {
    constructor(links) {
        super();
        this.links = links;
    }
    request(operation, forward) {
        const link = this.links.get(operation.getContext().clientName || 'default');
        if (link) {
            return link.request(operation, forward);
        }
        return null;
    }
}
